import type { FaireThemeEntity } from "../../entity_types/theme";

export const gourmet_confectionery_corner: FaireThemeEntity = {
  token: "gourmet-confectionery-corner",
  type: "theme",
  name: "Gourmet Confectionery Corner",
  description: "Elevate your snack selection with artisanal marzipan, rich fudge, and international treats. These premium sweets are perfect for gifting or as a high-quality impulse buy at your checkout counter.",
  teaser: "Shiva's Gift Shop already has a strong track record of ordering specialized snacks like Milka cookies, Kinder Bueno, and Ferrero Rocher bars, and emphasizes quality signals like 'artisanal' and 'small-batch.'",
  detail: "This theme directly addresses recent search queries for 'marzipan candy,' 'fudge,' 'favorina candy,' and 'candy,' indicating a clear intent to expand your sweet treats inventory.",
  bgColor: "#FFD4D4",
  tileBgColor: "#6b4631",
  exactProducts: true,
  retailerToken: "r_31m33roqxk",
  productTokens: [
    "p_j6snhz9tk5",
    "p_qvr3rd46xd",
    "p_znh8thcmbp",
    "p_2cepabe4ys",
    "p_6ntf568hwg",
    "p_69lsb7ocy7",
    "p_7xagxx6gys",
    "p_a5n8qvf8ss",
    "p_ns3d6ug3xs",
    "p_mgjtx3u5nd",
    "p_vm7ajj96d5",
    "p_a2taw5gsbg",
    "p_mn95k4k55w",
    "p_5dyrqvwypm",
    "p_b4mkcw2eea",
    "p_c6ykvmgk7s",
    "p_h6tj8guhjc",
    "p_zqcku3zdhu",
    "p_psfyh5rbww",
    "p_x9u88cjqj5",
    "p_5yd5295h30",
    "p_pxctmbuyg9",
    "p_j7c8gbyy44",
    "p_prq6qhfgth",
    "p_mjhm8ssxd3",
    "p_jr48nsjrkb",
    "p_z2btsty9cs",
    "p_4uq3cknhwm",
    "p_3kmzkcyhgq",
    "p_63y96wr9td",
    "p_kk6fnjsnfv",
    "p_76kwqwu589",
    "p_nk32hcwmpy",
    "p_p5ryh5sa6x",
    "p_k2h6gzes6c",
    "p_9prbz7fghz",
    "p_twyhswjnxs",
    "p_vfrzu3g2vw",
    "p_4kxy3xgbs2",
    "p_c80cn240m1",
    "p_7w3ks5pj22",
    "p_dej4b10w4l",
    "p_3gn2vai6an",
    "p_27ahsmqjtu",
    "p_fj7v5hvneb",
    "p_nn8pnb85xq",
    "p_nxvdhqkt4d",
    "p_r7a8m6xxpj",
    "p_26uar648p7",
    "p_hucyhj6qqs",
    "p_4agf3e90m1",
    "p_u527wdh5wy",
    "p_b3bnu6sskt",
    "p_7fpm7cfcgx",
    "p_9rqyz3ytcf",
    "p_m9xk689keb",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
